import ComingSoon from '../../components/common/ComingSoon';
import { Images } from '../../utils/imageConstants';

const LeagueManagerComingSoon = () => (
  <ComingSoon
    logoSrc={Images.main_logo}
    headline="League Manager Feature Coming Soon..."
    description="This feature is under development and will be available soon.
Stay tuned!"
  />
);

export default LeagueManagerComingSoon;
